import i18n from 'i18next';

export const usersTokenTemplate = (state) => `
  <div class="users-token-container">
    <h2>${i18n.t('users_token.ACCESS_TOKEN_REQUEST')}</h2>

    <div class="users-token-card">
      <h3>${i18n.t('users_token.USER_REGISTRATION')}</h3>

      <form id="users-token-form">
        <div class="form-group">
          <label>${i18n.t('users_token.FIRST_NAME')}:</label>
          <input type="text" name="firstname" value="${
            state.firstname || ''
          }" required />
        </div>

        <div class="form-group">
          <label>${i18n.t('users_token.LAST_NAME')}:</label>
          <input type="text" name="lastname" value="${
            state.lastname || ''
          }" required />
        </div>

        <div class="form-group">
          <label>${i18n.t('users_token.EMAIL')}:</label>
          <input type="email" name="email" value="${
            state.email || ''
          }" required title="${i18n.t('users_token.INVALID_EMAIL_TITLE')}" />
        </div>

        <div class="form-group">
          <label>${i18n.t('users_token.PURPOSE')}:</label>
          <input type="text" name="purpose" value="${
            state.purpose || ''
          }" required />
        </div>

        <button
          type="submit"
          class="esios-btn esios-btn--document esios-btn__icon"
          ${state.loading ? 'disabled' : ''}
        >
          ${
            state.loading
              ? i18n.t('users_token.SUBMITTING')
              : i18n.t('users_token.SUBMIT')
          }
        </button>
      </form>

      ${
        state.status === 'success'
          ? `
        <div class="result-card success">
          <div class="result-card__header">
            <div class="result-card__icon result-card__icon--success" aria-hidden="true">✓</div>
            <h4>${i18n.t('users_token.SUCCESS_TITLE')}</h4>
          </div>
          <p>${i18n.t('users_token.SUCCESS_TEXT')}</p>
        </div>
      `
          : ''
      }

      ${
        state.status === 'exists'
          ? `
        <div class="result-card error">
          <div class="result-card__header">
            <div class="result-card__icon result-card__icon--error" aria-hidden="true">✕</div>
            <h4>${i18n.t('users_token.ERROR_TITLE')}</h4>
          </div>
          <p>${i18n.t('users_token.EXIST_EMAIL')}</p>
          <p>${i18n.t('users_token.EXIST_EMAIL1')}</p>
        </div>
      `
          : ''
      }

      ${
        state.status === 'error'
          ? `
        <div class="result-card error">
          <div class="result-card__header">
            <div class="result-card__icon result-card__icon--error" aria-hidden="true">✕</div>
            <h4>${i18n.t('users_token.ERROR_TITLE')}</h4>
          </div>
          <p>${i18n.t('users_token.ERROR_TEXT_1')}</p>
          <p>${i18n.t('users_token.ERROR_TEXT_2')}</p>
        </div>
      `
          : ''
      }
    </div>
  </div>
`;
